import Vue from "vue";
import { ValidationObserver, ValidationProvider, extend, localize, setInteractionMode } from "vee-validate";
import { required, regex, max } from "vee-validate/dist/rules";

import ru from "vee-validate/dist/locale/ru.json";

import moment from "moment";

extend("required", required);
extend("regex", regex);
extend("max", max);

extend("date", {
    validate(value) {
        return moment(value, "DD.MM.YYYY", true).isValid();
    },
    message: "Неверный формат",
});

extend("time", {
    validate(value) {
        return moment(value, "HH:mm", true).isValid();
    },
    message: "Неверный формат",
});

extend("url", {
    validate(value) {
        if (value) {
            return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(value);
        }

        return false;
    },
    message: "Неверный формат",
});

localize(({ ru }));

localize({
    ru: {
        messages: {
            required: "Обязательное поле",
            regex: "Неверный формат",
        },
    },
});

localize("ru");

setInteractionMode("eager");

Vue.component("vee-observer", ValidationObserver);
Vue.component("vee-provider", ValidationProvider);
